import React, { useState } from "react";
import { createLinkedTodo, postComptaStageForm, finalizeComptaStage } from "./comptaStageHelpers";
import NotifyPicker from "./NotifyPicker";
import { CommentField, ReadField, SubmitBar } from "./FormFields";
import { cardCls, labelCls, inputCls } from "./formStyles";

// Étape 2/5 — Tri et numérisation (tache.type "Tri et numérisation"),
// anciennement handleSubmitTRI / tache.triForm.
function TriStage({
  tache,
  showFormInstead,
  selectedClient,
  selectedYear,
  selectedMonth,
  refetch,
  setShowOverlay,
  allUsers,
  utilisateur,
}) {
  const [formData, setFormData] = useState({
    qualiteOrganisation: "",
    tempsTraitement: "",
    commentaireTri: "",
    userIds: [],
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async () => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      // 1. Création du todo — échec avalé (comme l'origine), todoId reste null.
      // Note : le formData.commentaire du todo d'origine référençait le champ
      // "commentaire" (celui de l'étape Arrivé PC, partagé dans l'ancien
      // formData global) qui est systématiquement vide à ce stade du parcours
      // normal (reset après chaque soumission) — on reproduit fidèlement
      // cette valeur pratique en la passant vide ici.
      const todoId = await createLinkedTodo({
        title: "Traitement comptable niv.2- Suivi Compta",
        selectedClient,
        userIds: [selectedClient?.id_collaborateur_niv2 || 39],
        commentaire: "",
      });

      // 2. Envoi du TRI
      const payloadTri = {
        qualiteOrganisation: formData.qualiteOrganisation,
        tempsTraitement: formData.tempsTraitement,
        commentaire: formData.commentaireTri,
        assignedTo: formData.userIds.join(","),
        TodoCreate: todoId,
      };

      const tacheId = await postComptaStageForm({
        clientId: selectedClient.id,
        year: selectedYear,
        month: selectedMonth,
        stage: "tri",
        payload: payloadTri,
        sendErrorMessage: "Erreur lors de l’envoi du TRI",
      });

      const emailTriPayload = {
        NomComplet: `${utilisateur.lastName} ${utilisateur.name}`,
        qualiteOrganisation: formData.qualiteOrganisation,
        tempsTraitement: formData.tempsTraitement,
        commentaire: formData.commentaireTri,
        userEmails: formData.userIds,
      };
      const clientIdTri = selectedClient.id;

      setLoading(false);
      setShowOverlay(false);
      setSuccess(true);
      setFormData({ qualiteOrganisation: "", tempsTraitement: "", commentaireTri: "", userIds: [] });

      finalizeComptaStage({
        clientId: clientIdTri,
        tacheId,
        emailEndpoint: "https://backend-myalfa.vercel.app/api/email-tri",
        emailPayload: emailTriPayload,
        prevTodoEndpoint: `https://backend-myalfa.vercel.app/api/compta/${clientIdTri}/${selectedYear}/${selectedMonth}/arrivePC/todo`,
        refetch,
      });
    } catch (err) {
      setError(err.message);
      setLoading(false);
      setShowOverlay(false);
    }
  };

  return (
    <>
      {showFormInstead && (
        <form
          className={cardCls}
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit(tache.id);
          }}
        >
          <p className="text-sm font-bold text-[#5C1A30]">2 / Validation SCAN / TRI</p>

          <div>
            <label className={labelCls}>Qualité d'organisation</label>
            <select
              value={formData.qualiteOrganisation}
              onChange={(e) => setFormData({ ...formData, qualiteOrganisation: e.target.value })}
              className={inputCls}
            >
              <option value="">Veuillez sélectionner</option>
              {["Nulle", "Bonne", "Excellente"].map((item) => (
                <option key={item} value={item}>
                  {item}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className={labelCls}>Temps de traitement approximatif</label>
            <input
              type="text"
              value={formData.tempsTraitement}
              onChange={(e) => setFormData({ ...formData, tempsTraitement: e.target.value })}
              className={inputCls}
            />
          </div>

          <CommentField
            value={formData.commentaireTri}
            onChange={(e) => setFormData({ ...formData, commentaireTri: e.target.value })}
          />

          <NotifyPicker allUsers={allUsers} formData={formData} setFormData={setFormData} />

          <SubmitBar loading={loading} error={error} success={success} />
        </form>
      )}

      {tache.triForm && (
        <div className={cardCls}>
          <ReadField label="Organisation" value={tache.triForm.qualiteOrganisation} />
          <ReadField label="Temps traitement" value={tache.triForm.tempsTraitement} />
          <ReadField label="Commentaire" value={tache.triForm.commentaire} />
          <ReadField
            label="Date de création"
            value={new Date(tache.triForm.createdAt).toLocaleString()}
          />
        </div>
      )}
    </>
  );
}

export default TriStage;
